import type { ReactNode } from "react"
import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { getPrintOrderPageName } from "./printMarginBoxes"

type StyleProps = Readonly<{
    orderId: number
}>

const useStyles = makeStyles<StyleProps>()((_theme, { orderId }) => ({
    root: {
        "@media print": {
            // a lone order stays on the plain page, which already shows its number
            "&:not(:only-child)": {
                page: getPrintOrderPageName(orderId),
            },
            breakAfter: "page",
            "&:last-child": {
                breakAfter: "auto",
            },
        },
    },
}))

type PrintOrderPageProps = Readonly<{
    orderId: number
    children: ReactNode
}>

export function PrintOrderPage({ orderId, children }: PrintOrderPageProps) {
    const { classes } = useStyles({ orderId })

    return <Box className={classes.root}>{children}</Box>
}
